var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArbitrum(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 164,
    viewBox: "0 0 164 164",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4594_7867)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.3728 78.0813L99.1338 66.4037L117.357 95.2962L117.365 100.841L117.306 62.6858C117.263 61.7532 116.776 60.8999 116 60.3968L83.1917 41.1863C82.4243 40.8024 81.4509 40.8065 80.685 41.1982C80.5816 41.2511 80.4841 41.3084 80.3913 41.371L80.277 41.4443L48.4311 60.2298L48.3074 60.2868C48.1486 60.3613 47.988 60.4558 47.8372 60.5657C47.2335 61.0066 46.8324 61.6583 46.7027 62.3895C46.6833 62.5003 46.669 62.6131 46.6621 62.7268L46.7121 93.8194L63.6861 67.0385C65.8231 63.4873 70.4794 62.3435 74.8017 62.4058L79.8748 62.5422L49.9842 111.338L53.5077 113.403L83.7565 62.5916L97.1265 62.5422L66.9556 114.636L79.5285 121.997L81.0307 122.877C81.6661 123.14 82.4152 123.153 83.056 122.917L116.325 103.291L109.965 107.043L92.3728 78.0813ZM94.9523 115.899L82.2535 95.6111L90.0052 82.2211L106.683 108.979L94.9523 115.899Z",
    fill: "url(#paint0_linear_4594_7867)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.252 95.6107L94.9508 115.899L106.681 108.979L90.004 82.2207L82.252 95.6107Z",
    fill: "url(#paint1_linear_4594_7867)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.364 100.84L117.355 95.2958L99.1321 66.4033L92.3711 78.0809L109.963 107.043L116.324 103.291C116.948 102.775 117.325 102.018 117.365 101.202L117.364 100.84Z",
    fill: "url(#paint2_linear_4594_7867)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0003 106.069L49.9825 111.337L79.8731 62.5414L74.8 62.405C70.4778 62.3427 65.8218 63.4865 63.6845 67.0378L46.7105 93.8186L41 102.75V106.069H41.0003Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.1263 62.541L83.7567 62.5905L53.5078 113.402L64.0805 119.599L66.9558 114.635L97.1263 62.541Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123 62.4715C122.888 59.6252 121.374 57.0194 119.003 55.5025L85.7644 36.0451C83.4186 34.8426 80.4879 34.8411 78.1383 36.0443C77.8606 36.1868 45.8145 55.1058 45.8145 55.1058C45.3711 55.3222 44.944 55.5802 44.542 55.8727C42.425 57.4173 41.1345 59.8171 41.002 62.454V102.75L46.7124 93.8191L46.6624 62.7265C46.6693 62.6128 46.6833 62.5011 46.703 62.3906C46.8319 61.6589 47.2333 61.0063 47.8375 60.5654C47.9883 60.4555 80.5816 41.2508 80.6853 41.1979C81.4515 40.8062 82.4249 40.8021 83.192 41.186L116 60.3965C116.777 60.8996 117.263 61.7528 117.306 62.6855V101.202C117.267 102.018 116.949 102.775 116.326 103.291L109.965 107.043L106.683 108.979L94.9524 115.899L83.056 122.917C82.4152 123.153 81.6661 123.14 81.0307 122.876L66.9557 114.636L64.0804 119.599L76.7293 127.013C77.1475 127.255 77.5204 127.469 77.8261 127.644C78.2998 127.915 78.6223 128.096 78.7363 128.152C79.6354 128.596 80.9287 128.855 82.0944 128.855C83.1632 128.855 84.2051 128.655 85.1913 128.262L119.745 107.892C121.728 106.328 122.895 103.969 123 101.414V62.4715Z",
    fill: "url(#paint3_linear_4594_7867)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4594_7867",
    x: 33,
    y: 31.1426,
    width: 98,
    height: 109.712,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.14902 0 0 0 0 0.568627 0 0 0 0 0.870588 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4594_7867"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4594_7867",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4594_7867",
    x1: 82.0138,
    y1: 40.9014,
    x2: 82.0138,
    y2: 123.084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#081520"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B2233"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4594_7867",
    x1: 94.4667,
    y1: 82.2207,
    x2: 94.4667,
    y2: 115.899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#279DEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#064773"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4594_7867",
    x1: 104.868,
    y1: 66.4033,
    x2: 104.868,
    y2: 107.043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28A0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04436C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4594_7867",
    x1: 82.0009,
    y1: 35.1426,
    x2: 82.0009,
    y2: 128.855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#279BEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#152D58"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArbitrum);
export default __webpack_public_path__ + "static/media/arbitrum.0a17f826a21887f825a6a89101d70812.svg";
export { ForwardRef as ReactComponent };